import { UserProfile } from '@providers/api/user/user.data.interface';
import { QuestionnaireActiveForm } from './active.interface';
import {
  qUtilsActiveFilterDefaultOption,
  qUtilsActiveFindDefaultOption
} from './active.utils';

/**
 * @description Questionnaire Active State.
 * @exports
 * @interface QuestionnaireActiveState
 */
export interface QuestionnaireActiveState {
  form: QuestionnaireActiveForm;
  userProfile: UserProfile | null;
  loading: {
    submit: boolean;
    fetchUserProfile: boolean;
  };
  submissionResponse: {
    success: boolean | null;
    message?: string | null;
    response: unknown | null;
  };
}

/**
 * @description Initial state for Questionnaire Active.
 * @returns {QuestionnaireActiveState}
 */
export const intialQuestionnaireActiveState = (): QuestionnaireActiveState => ({
  userProfile: null,
  form: {
    information: {
      height: null,
      weight: null
    },
    exerciseCurrentDetails: {
      exerciseCurrently: qUtilsActiveFilterDefaultOption(
        'exerciseCurrentDetails.exerciseCurrently'
      ),
      exerciseTimesPerWeek: qUtilsActiveFindDefaultOption(
        'exerciseCurrentDetails.exerciseTimesPerWeek'
      ),
      exerciseTimesPerWeekValue: null,
      exerciseMinutesPerSession: qUtilsActiveFindDefaultOption(
        'exerciseCurrentDetails.exerciseMinutesPerSession'
      ),
      exerciseMinutesPerSessionValue: null
    },
    fitnessGoals: qUtilsActiveFindDefaultOption('fitnessGoals'),
    injuryHistory: qUtilsActiveFindDefaultOption('injuryHistory'),
    medicalHistory: qUtilsActiveFilterDefaultOption('medicalHistory')
  },
  loading: {
    submit: false,
    fetchUserProfile: false
  },
  submissionResponse: {
    success: null,
    message: null,
    response: null
  }
});

export const questionnaireActiveKey = 'questionnaire-active';
export const questionnaireActiveState: QuestionnaireActiveState =
  intialQuestionnaireActiveState();
